/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { User } from '../../../../../models/User';
import { UrlfixPipe } from '../../../../../pipes/urlfix.pipe';
import { UtilFunctions } from '../../../util-functions';

const validator = require('validator');

@Component({
  selector: 'app-ctv-developer-overview',
  templateUrl: './ctv-developer-overview.component.html',
  styleUrls: ['./ctv-developer-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvDeveloperOverviewComponent implements OnChanges {
  @Input() data: any;
  @Input() isFreemium: boolean;
  @Input() isFollowing: boolean;
  @Output() goToAppDiscovery: EventEmitter<any> = new EventEmitter<any>();
  @Output() followClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  developerOverview: any;
  urlFixPipe: UrlfixPipe = new UrlfixPipe();

  constructor(public _userService: User) {}

  toAppDiscoveryClick(details: any) {
    this.goToAppDiscovery.emit(details);
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'data') {
        const developerOverview = this.data.developerOverview;
        developerOverview.website = UtilFunctions.toWebsiteURL(
          developerOverview.website,
          validator
        );
        this.developerOverview = developerOverview;
      }
    }
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
